function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3.175 3.175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.154 1.657c.013-.014.014-.042.014-.07 0-.027 0-.054-.014-.069 0-.027-.028-.056-.042-.07L1.865.202c-.083-.083-.194-.083-.278 0-.083.084-.083.195 0 .278l.915.915H.2a.19.19 0 0 0-.194.194.18.18 0 0 0 .055.138.18.18 0 0 0 .14.056h2.3l-.914.915c-.084.083-.084.194 0 .277.082.083.194.083.277 0l1.247-1.248c.014-.013.042-.041.042-.07",
    style: {
      strokeWidth: 0.196025
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.8bd5b2f8503532e4bf9df012c6f135cf.svg";
export { ForwardRef as ReactComponent };